export default __webpack_public_path__ + "static/media/26.a28aa410.jpg";